<mat-tab-group [selectedIndex]="currentViewIndex()" (selectedIndexChange)="selectTab($event)">
  @for (view of shipmentViews(); track view.id) {
    <mat-tab
      [label]="view.caption"
    ></mat-tab>
  }
</mat-tab-group>

<app-shipments-table-filter></app-shipments-table-filter>

<div class="content-spacer">
  <app-shipment-table></app-shipment-table>
</div>

